import formularioImovel from '@/App/(authenticated)/modulos/cadastro/formulario-cadastro/imovel/imovel.vue'
import formularioUsoSolo from '@/App/(authenticated)/modulos/cadastro/formulario-cadastro/uso-solo/uso-solo.vue'
import formularioPraticas from '@/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/praticas.vue'
import formularioAnexos from '@/App/(authenticated)/modulos/cadastro/formulario-cadastro/anexos/anexos.vue'
import cadastroPraticas from '@/App/(authenticated)/modulos/cadastro/formulario-cadastro/cadastro'
import formularioProprietario from '@/App/(authenticated)/modulos/cadastro/formulario-cadastro/proprietario/proprietario.vue'
import formularioGeorreferenciamento from '@/App/(authenticated)/modulos/cadastro/formulario-cadastro/georreferenciamento/georreferenciamento.vue'

export const items = [
  {
    path: 'praticas/new',
    name: 'praticas/new',
    component: cadastroPraticas,
    props: true,
    redirect: route => ({
      name: route.params.tipoCadastro === 'EMPRESA' ? 'formulario-imovel' : 'formulario-proprietario'
    })
  },
  {
    path: 'praticas/:idCadastro/:tipoCadastro',
    name: 'praticas',
    component: cadastroPraticas,
    props: route => ({
      tipoCadastro: route.params.tipoCadastro
    }),
    redirect: { name: 'formulario-proprietario' },
    children: [
      {
        path: 'formulario-proprietario',
        name: 'formulario-proprietario',
        component: formularioProprietario
      },
      {
        path: 'formulario-imovel',
        name: 'formulario-imovel',
        component: formularioImovel
      },
      {
        path: 'formulario-uso-solo',
        name: 'formulario-uso-solo',
        component: formularioUsoSolo
      },
      {
        path: 'formulario-praticas',
        name: 'formulario-praticas',
        component: formularioPraticas
      },
      {
        path: 'formulario-anexos',
        name: 'formulario-anexos',
        component: formularioAnexos
      },
      {
        path: 'formulario-georreferenciamento',
        name: 'formulario-georreferenciamento',
        component: formularioGeorreferenciamento
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/cadastro/routes.js